import html from './term_and_conditions.html.js';
var htmlDoc = {__html: html};

function Tnc() {
  return <div dangerouslySetInnerHTML={htmlDoc} />;
}

export default Tnc;
